export { default } from './HeroWithoutContent';
